angular.module('concept-map')
    .service('svgDom', [function() {
        var namespace = "http://www.w3.org/2000/svg";

        var createTextNode = function(x, y, text) {

            var e = document.createElementNS(namespace, 'text');
            e.setAttribute('x', x);
            e.setAttribute('y', y);
            e.setAttribute('font-size', '14px');
            e.setAttribute('fill', 'white');
            e.setAttribute('font-weight', 'bold');
            e.setAttribute('font-family', 'Proxima Nova Condensed'); // TODO: change to css
            e.innerHTML = text;
            return e;
        };

        var createUseNode = function(x, y, width, height, xlink, className) {

            var e = document.createElementNS(namespace, 'use');
            e.setAttribute('x', x);
            e.setAttribute('y', y);
            e.setAttributeNS('http://www.w3.org/1999/xlink', 'href', xlink);
            e.setAttribute('width', width);
            e.setAttribute('height', height);
            e.setAttribute('class', className);
            return e;
        };

        // a util function to get the first node by its class
        // it is only useful when the parent only has a single node with the class name we care
        var getFirstChildByClass = function(parent, classSelector) {
            var icons = parent.querySelectorAll(classSelector);
            return icons.length !== 0 ? icons[0] : null;
        };

        return {
            createTextNode: createTextNode,
            createUseNode: createUseNode,
            getFirstChildByClass: getFirstChildByClass
        };

    }]
);
